<template>
  <footer class="footer">
    <!-- <p class="linkLine">
			<a v-for="(item,index) in link" :key="index" :href="item.src" target="_blank">{{item.name}}</a>
		</p> -->
    <p v-if="lang === 'zh'" class="icp">
      ©2015-{{ new Date().getFullYear() }} checkout.pingpongx.com.
      杭州乒乓智能技术有限公司 All Rights Reserved.
      <br>浙ICP备15025700号-1. 经营许可证:合字B2-20200174 浙公网安备
      33010802003226号
    </p>
    <p v-else class="icp">
      2015-{{ new Date().getFullYear() }} © PingPong All rights reserved.
    </p>
  </footer>
</template>
<script>
export default {
  name: 'LoginFooter',
  props: {},
  data() {
    return {
      lang: this.$i18n.locale,
      link: []
    }
  }
}
</script>
<style lang="scss" scoped>
.footer {
	width: 100%;
	text-align: center;
	padding: 16px;
	box-sizing: border-box;
	&.mobile {
		.linkLine {
			padding-bottom: 13px;
			a {
				margin-right: 10px;
			}
		}
	}

	.linkLine {
		line-height: 15px;
		padding-bottom: 28px;
		a {
			font-size: 14px;
			color: #666666;
			margin-right: 30px;
		}
	}
	.desc {
		font-size: 12px;
		color: #999999;
		letter-spacing: 0;
	}
	.icp {
		line-height: 20px;
		font-size: 10px;
		color: #999999;
	}
}
</style>
